/* tslint:disable */

declare var Object: any;
export interface PacienteInterface {
  "name": string;
  "id": string;
  "avatar"?: string;
  "state"?: number;
  "company"?: string;
  "number"?: string;
  "lastname"?: string;
  "created"?: Date;
  "codigoVendedor"?: string;
  "nroSobre"?: string;
  "nroArreglo"?: string;
}

export class Paciente implements PacienteInterface {
  "name": string;
  "id": string;
  "avatar": string;
  "state": number;
  "company": string;
  "number": string;
  "lastname": string;
  "created": Date;
  "codigoVendedor": string;
  "nroSobre": string;
  "nroArreglo": string;
  constructor(data?: PacienteInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Paciente`.
   */
  public static getModelName() {
    return "Paciente";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Paciente for dynamic purposes.
  **/
  public static factory(data: PacienteInterface): Paciente{
    return new Paciente(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Paciente',
      plural: 'Pacientes',
      path: 'Pacientes',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'string'
        },
        "avatar": {
          name: 'avatar',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'number'
        },
        "company": {
          name: 'company',
          type: 'string'
        },
        "number": {
          name: 'number',
          type: 'string'
        },
        "lastname": {
          name: 'lastname',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "codigoVendedor": {
          name: 'codigoVendedor',
          type: 'string'
        },
        "nroSobre": {
          name: 'nroSobre',
          type: 'string'
        },
        "nroArreglo": {
          name: 'nroArreglo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/Paciente.ts